import { toast } from 'react-toastify';
import {
  ONBOARD,
  ONBOARD_SUCCESS,
  ONBOARD_FAILURE,
  ONBOARD_VALIDATION_FAILED,
} from '../actions/OnboardActions';
import { SIGNED_OUT } from '../actions/index';

const initialState = {
  onboard: undefined,
  loading: false,
  validationError: [],
};

export default function signIn(state = initialState, action) {
  switch (action.type) {
    case ONBOARD:
      return {
        ...state,
        loading: true,
      };
    case ONBOARD_SUCCESS:
      toast.success(action.credentials.message);
      const credentials = {
        redirect: true,
      };
      return { ...state, onboard: credentials };
    case ONBOARD_FAILURE:
      localStorage.removeItem('access_token');
      toast.success(action.message);
      return { ...state, onboard: undefined };

    case ONBOARD_VALIDATION_FAILED:
      toast.error(action.message);
      return {
        ...state,
        loading: false,
        validationError: action.errors,
      };
    case SIGNED_OUT:
      return { ...initialState };
    default:
      return state;
  }
}
